;(function (): void {
    const me = document.currentScript as HTMLScriptElement | null
    if (!me) {
        return
    }

    const loaderSrc = me.getAttribute('src')
    if (!loaderSrc) {
        return
    }

    const loaderUrl = new URL(loaderSrc)
    const base = `${loaderUrl.origin}${loaderUrl.pathname.substring(0, loaderUrl.pathname.lastIndexOf('/'))}`
    const ver = me.getAttribute('data-version') || 'latest'
    const src = `${base}/${ver}/rs-webinar-registration-form.min.js`

    if (window.__RV_EVENT_REG_LOADING__) {
        return
    }
    window.__RV_EVENT_REG_LOADING__ = true

    const s = document.createElement('script')
    s.src = src
    s.async = true
    s.crossOrigin = 'anonymous'
    s.onerror = function (): void {
        window.__RV_EVENT_REG_LOADING__ = false
    }
    s.onload = function (): void {
        if (typeof window.RV_EVENT_REG_INIT === 'function') {
            window.RV_EVENT_REG_INIT({
                apiBase: me.getAttribute('data-api-base') || 'https://riverside.com',
                graphqlEndpoint: me.getAttribute('data-graphql-endpoint') || 'https://riverside.com/graphql',
                eventId: me.getAttribute('data-event-id'),
                target: me.getAttribute('data-target') || 'body',
                labels: tryJSON(me.getAttribute('data-labels')) || null,
                // Optional override; without it the widget follows the event's language.
                language: me.getAttribute('data-language') || null,
            })
        }
    }
    document.head.appendChild(s)

    function tryJSON(jsonString: string | null): any {
        if (!jsonString) {
            return null
        }
        try {
            return JSON.parse(jsonString)
        } catch (_err) {
            return null
        }
    }
})()
